import React from 'react';

const C = {
  bg:'#08090f', card:'#0d1117', inp:'#0f1420',
  border:'#1f2937', borderS:'#1a2035',
  primary:'#e5e7eb', secondary:'#6b7280', muted:'#374151',
  profit:'#16C784', loss:'#ef4444', accent:'#6366f1',
};

function SDiv({ label }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:8, margin:'4px 0' }}>
      <div style={{ flex:1, height:1, background:C.borderS }}/>
      <span style={{ color:C.muted, fontSize:9, fontWeight:800, letterSpacing:2, textTransform:'uppercase' }}>{label}</span>
      <div style={{ flex:1, height:1, background:C.borderS }}/>
    </div>
  );
}

function SCard({ children, accent, style={} }) {
  return (
    <div style={{
      borderRadius:12, padding:'10px 12px', boxSizing:'border-box',
      background: accent ? `linear-gradient(135deg,${accent}12 0%,${C.card} 100%)` : C.card,
      border:`1px solid ${accent ? `${accent}28` : C.border}`, ...style,
    }}>
      {children}
    </div>
  );
}

function SHead({ emoji, title, color }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:8 }}>
      <div style={{ width:20, height:20, borderRadius:6, background:`${color||C.accent}22`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, fontSize:11 }}>
        {emoji}
      </div>
      <span style={{ color:C.primary, fontSize:11, fontWeight:800, textTransform:'uppercase', letterSpacing:1 }}>{title}</span>
    </div>
  );
}

function MC({ label, value, color }) {
  return (
    <div style={{ padding:'5px 8px', borderRadius:8, background:color?`${color}10`:C.inp, border:`1px solid ${color?`${color}22`:C.border}` }}>
      <div style={{ color:C.secondary, fontSize:8, fontWeight:600, marginBottom:1 }}>{label}</div>
      <div style={{ color:color||C.primary, fontSize:11, fontWeight:800, lineHeight:1.2 }}>{value??'—'}</div>
    </div>
  );
}

function Pill({ label, color }) {
  return (
    <span style={{ display:'inline-block', background:`${color}18`, color, border:`1px solid ${color}28`, borderRadius:20, padding:'2px 8px', fontSize:9, fontWeight:700, marginRight:3, marginBottom:3 }}>
      {label}
    </span>
  );
}

function RegimeDayShareCard({ day, cardRef }) {
  if (!day) return null;

  const matchColor  = day.conflict?'#f59e0b':day.match?C.profit:C.loss;
  const matchLabel  = day.conflict?'Signal Conflict':day.match?'Signal Followed':'Signal Diverged';
  const biasColor   = (b)=>b==='bull'||b==='buy'?C.profit:b==='bear'||b==='sell'?C.loss:C.secondary;
  const biasLabel   = (b)=>b==='bull'||b==='buy'?'↑ Bull':b==='bear'||b==='sell'?'↓ Bear':'─ Neutral';
  const gapBias     = (gt)=>gt?.includes('up')?'bull':gt?.includes('down')?'bear':'neutral';
  const actualColor = day.actual==='bull'?C.profit:day.actual==='bear'?C.loss:C.secondary;

  const foP = day.foPerformance;
  let bestTrade=null, worstTrade=null;
  if (foP) {
    const ceWon = foP.CE?.pct!=null&&foP.PE?.pct!=null&&foP.CE.pct>foP.PE.pct;
    bestTrade  = ceWon?{label:'CE Buy (Bullish)',color:C.profit,reason:`Call ${foP.CE?.pct>=0?'+':''}${foP.CE?.pct}%`}:{label:'PE Buy (Bearish)',color:C.profit,reason:`Put ${foP.PE?.pct>=0?'+':''}${foP.PE?.pct}%`};
    worstTrade = ceWon?{label:'CE Sellers',color:C.loss,reason:'Sold calls against the move'}:{label:'CE Buy (Bullish)',color:C.loss,reason:'Buying calls on a bear day'};
  }
  let entryStrategy = null;
  if (day.conflict)     entryStrategy={label:'Sit out or minimum size',color:C.secondary,reason:'Signals were contradictory.'};
  else if (!day.match)  entryStrategy={label:'Fade at 9:35',color:'#f59e0b',reason:'Setup diverged — fade the gap direction.'};
  else                  entryStrategy={label:'Trade with setup at open',color:C.profit,reason:'Setup followed through.'};

  return (
    <div
      ref={cardRef}
      style={{
        width:1080, height:1350, background:C.bg, overflow:'hidden', position:'relative',
        fontFamily:"'Segoe UI',system-ui,-apple-system,sans-serif",
        display:'flex', flexDirection:'column', padding:28, gap:7, boxSizing:'border-box',
      }}
    >
      {/* Ambient glow */}
      <div style={{ position:'absolute', top:-80, right:-80, width:200, height:200, borderRadius:'50%', background:`radial-gradient(circle,${matchColor}0e 0%,transparent 65%)`, pointerEvents:'none' }}/>

      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:4, flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:28, height:28, borderRadius:8, background:'linear-gradient(135deg,#22c55e30,#22c55e10)', border:'1px solid #22c55e35', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#22c55e', fontSize:14, fontWeight:900 }}>T</span>
          </div>
          <span style={{ color:'#fff', fontSize:16, fontWeight:800 }}>TradeReflex</span>
        </div>
        <span style={{ color:C.muted, fontSize:11 }}>Market Regime · Daily</span>
        <span style={{ color:C.muted, fontSize:11 }}>tradereflex.in</span>
      </div>

      {/* Hero */}
      <SCard accent={matchColor}>
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:6 }}>
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4, flexWrap:'wrap' }}>
              <span style={{ color:'#fff', fontSize:26, fontWeight:900, letterSpacing:'-0.5px', lineHeight:1 }}>{day.date}</span>
              <Pill label={matchLabel} color={matchColor}/>
            </div>
            <p style={{ color:actualColor, fontSize:32, fontWeight:900, margin:0, lineHeight:1, letterSpacing:'-1px' }}>{day.actualLabel||'—'}</p>
            <p style={{ color:C.secondary, fontSize:11, margin:'3px 0 0' }}>Nifty closed {day.dayType||matchLabel}{day.lockTime?` · Locked ${day.lockTime}`:''}</p>
          </div>
        </div>
      </SCard>

      <SDiv label="Signal Breakdown"/>

      {/* 4 signal tiles */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:7 }}>
        {day.globalBias && <MC label="Global" value={biasLabel(day.globalBias)} color={biasColor(day.globalBias)}/>}
        {day.gapType    && <MC label="Gap"    value={biasLabel(gapBias(day.gapType))} color={biasColor(gapBias(day.gapType))}/>}
        {day.fiiBias    && <MC label="FII"    value={biasLabel(day.fiiBias)}    color={biasColor(day.fiiBias)}/>}
        {day.diiBias    && <MC label="DII"    value={biasLabel(day.diiBias)}    color={biasColor(day.diiBias)}/>}
      </div>

      {/* 2-column: Market Structure + Scanners */}
      <div style={{ display:'flex', gap:7 }}>
        {(day.breadth!=null||day.fo) && (
          <SCard style={{ flex:1 }}>
            <SHead emoji="📊" title="Market Structure" color="#8b5cf6"/>
            {day.breadth!=null && (
              <div style={{ marginBottom:day.fo?8:0 }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                  <span style={{ color:C.secondary, fontSize:10, fontWeight:700 }}>Breadth</span>
                  <span style={{ color:day.breadth>=60?C.profit:day.breadth<=40?C.loss:'#f59e0b', fontSize:11, fontWeight:800 }}>{day.breadth}% · {day.breadthCount}</span>
                </div>
                <div style={{ height:5, background:C.border, borderRadius:3, overflow:'hidden' }}>
                  <div style={{ width:`${day.breadth}%`, height:'100%', borderRadius:3, background:day.breadth>=60?C.profit:day.breadth<=40?C.loss:'#f59e0b' }}/>
                </div>
              </div>
            )}
            {day.fo && (
              <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
                <span style={{ color:C.secondary, fontSize:10, fontWeight:700 }}>ATM {day.fo.strike}</span>
                {['CE','PE','straddle'].map(key => {
                  const d = day.fo[key]; if (!d) return null;
                  const lbl = key==='CE'?'Call':key==='PE'?'Put':'Straddle';
                  const col = key==='straddle'?(d.pct>0?'#f59e0b':'#9ca3af'):(d.pct>0?C.profit:C.loss);
                  return <Pill key={key} label={`${lbl} ${d.pct>=0?'+':''}${d.pct}%`} color={col}/>;
                })}
              </div>
            )}
          </SCard>
        )}

        {day.scanners&&(day.scanners.bull?.signals>0||day.scanners.bear?.signals>0) && (
          <SCard accent="#f59e0b" style={{ flex:1 }}>
            <SHead emoji="📡" title="Scanner Signals" color="#f59e0b"/>
            <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
              {day.scanners.bull?.signals>0 && <Pill label={`${day.scanners.bull.signals} Bullish${day.scanners.bull.hit_rate!=null?` · ${day.scanners.bull.hit_rate}% hit`:''}`} color={C.profit}/>}
              {day.scanners.bear?.signals>0 && <Pill label={`${day.scanners.bear.signals} Bearish${day.scanners.bear.hit_rate!=null?` · ${day.scanners.bear.hit_rate}% hit`:''}`} color={C.loss}/>}
            </div>
          </SCard>
        )}
      </div>

      {/* Sectors */}
      {day.sectors?.length>0 && (
        <SCard>
          <SHead emoji="🏭" title="Sectors" color="#f59e0b"/>
          <div style={{ display:'flex', flexWrap:'wrap' }}>
            {day.sectors.slice(0,10).map(sec => {
              const col = sec.avg>=0?C.profit:C.loss;
              return <Pill key={sec.name} label={`${sec.name} ${sec.avg>=0?'+':''}${sec.avg}%`} color={col}/>;
            })}
          </div>
        </SCard>
      )}

      {/* 2-column: Day Debrief + Verdict */}
      <div style={{ display:'flex', gap:7 }}>
        {(bestTrade||entryStrategy) && (
          <SCard style={{ flex:1 }}>
            <SHead emoji="✅" title="Day Debrief" color={C.profit}/>
            <div style={{ display:'flex', flexDirection:'column', gap:7, borderTop:`1px solid ${C.border}` }}>
              {bestTrade && (
                <div style={{ display:'flex', gap:9, alignItems:'flex-start', paddingTop:7 }}>
                  <span style={{ fontSize:12 }}>✅</span>
                  <div>
                    <p style={{ color:bestTrade.color, fontSize:11, fontWeight:800, margin:'0 0 2px' }}>{bestTrade.label}</p>
                    <p style={{ color:C.secondary, fontSize:10, margin:0 }}>{bestTrade.reason}</p>
                  </div>
                </div>
              )}
              {worstTrade && (
                <div style={{ display:'flex', gap:9, alignItems:'flex-start' }}>
                  <span style={{ fontSize:12 }}>❌</span>
                  <div>
                    <p style={{ color:worstTrade.color, fontSize:11, fontWeight:800, margin:'0 0 2px' }}>{worstTrade.label}</p>
                    <p style={{ color:C.secondary, fontSize:10, margin:0 }}>{worstTrade.reason}</p>
                  </div>
                </div>
              )}
              {entryStrategy && (
                <div style={{ display:'flex', gap:9, alignItems:'flex-start' }}>
                  <span style={{ fontSize:12 }}>⏱</span>
                  <div>
                    <p style={{ color:entryStrategy.color, fontSize:11, fontWeight:800, margin:'0 0 2px' }}>{entryStrategy.label}</p>
                    <p style={{ color:C.secondary, fontSize:10, margin:0 }}>{entryStrategy.reason}</p>
                  </div>
                </div>
              )}
            </div>
          </SCard>
        )}

        {day.verdictSentence && (
          <SCard accent={matchColor} style={{ flex:1 }}>
            <SHead emoji="📋" title="Verdict" color={matchColor}/>
            <p style={{ color:C.primary, fontSize:12, lineHeight:1.55, margin:0, fontStyle:'italic' }}>{day.verdictSentence}</p>
          </SCard>
        )}
      </div>

      {/* Footer */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:8, borderTop:`1px solid ${C.borderS}`, flexShrink:0, marginTop:'auto' }}>
        <span style={{ color:C.muted, fontSize:10 }}>Know your edge · TradeReflex</span>
        <span style={{ color:C.secondary, fontSize:10, fontWeight:700 }}>tradereflex.in</span>
      </div>
    </div>
  );
}

export default RegimeDayShareCard;
